import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import { UserProvider, UserConsumer } from "./contexts/UserContext"
import { HistoryProvider } from "./contexts/HistoryContext"
import { SchemaProvider } from "./contexts/SchemaContext"
import { MessagingProvider } from "./contexts/MessagingContext"
import { ThemeProvider } from "@material-ui/core/styles"
import LoginPage from "./pages/LoginPage"
import theme from "./theme/mainTheme"
import * as serviceWorker from "./serviceWorker"

function Root() {
  return (
    <ThemeProvider theme={theme}>
      <UserConsumer>
        {({ user }) => (user ? <App user={user} /> : <LoginPage />)}
      </UserConsumer>
    </ThemeProvider>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <SchemaProvider>
        <HistoryProvider>
          <MessagingProvider>
            <Root />
          </MessagingProvider>
        </HistoryProvider>
      </SchemaProvider>
    </UserProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
